module.exports = __webpack_public_path__ + "static/media/reserve-body-image.3a571b0b.png";